import { FC } from "react";
import { IonButton, IonCard, IonIcon, IonItem } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { get } from "lodash";
import { eye, eyeOff } from "ionicons/icons";
import { R6IonInput } from "../../../components/r6ionic/R6IonInput";

export interface PasswordLoginFormProps {
    onSubmit: (data: any) => void | Promise<void>;
    showPassword: boolean;
    onTogglePasswordVisibility: () => void;
}

export const PasswordLoginForm: FC<PasswordLoginFormProps> = ({
    onSubmit,
    showPassword,
    onTogglePasswordVisibility,
}) => {
    const { t } = useTranslation();
    const {
        handleSubmit,
        formState: { errors },
    } = useFormContext();

    return (
        <IonCard color="transparent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <R6IonInput
                    name="email"
                    className={
                        get(errors, "email.message") ? "ion-invalid" : ""
                    }
                    testId="usernameInput"
                    rules={{
                        required: t("utils.ErrorMessages.required").toString(),
                    }}
                    inputMode="email"
                    autocapitalize="off"
                    label={`${t("login.login.emailPlaceholder")} / ${t(
                        "general.username"
                    )}`}
                />

                <div style={{ display: "flex" }}>
                    <R6IonInput
                        name="password"
                        className={
                            get(errors, "password.message") ? "ion-invalid" : ""
                        }
                        testId="passwordInput"
                        rules={{
                            required: t(
                                "utils.ErrorMessages.required"
                            ).toString(),
                        }}
                        type={showPassword ? "text" : "password"}
                        autocapitalize="off"
                        label={t("login.login.password").toUpperCase()}
                    />
                    <IonButton
                        fill="clear"
                        slot="end"
                        onClick={onTogglePasswordVisibility}
                        style={{ margin: 0 }}
                    >
                        <IonIcon
                            icon={showPassword ? eye : eyeOff}
                            slot="icon-only"
                        />
                    </IonButton>
                </div>
            </form>
        </IonCard>
    );
};
